import { DrawCabinetInsideElement } from "$src/CGS/domain/dto/article/Cabinet/Inside/DrawCabinetInsideElement";
import { AutoLength } from "$src/CGS/domain/dto/core/Length/AutoLength";
import { Length } from "$src/CGS/domain/dto/core/Length/Length";
import { LengthMaths } from "$src/CGS/domain/dto/core/Length/LengthMaths";
import LengthValue from "$src/CGS/domain/dto/core/Length/LengthValue";
import { LengthValueMillimeter } from "$src/CGS/domain/dto/core/Length/LengthValueMillimeter";
import RangeLength from "$src/CGS/domain/dto/core/Length/RangeLength";
import { StarLength } from "$src/CGS/domain/dto/core/Length/StarLength";
import { InsideComputation } from "./InsideComputation";

export class InsideElementComputation extends InsideComputation {
    public context: DrawCabinetInsideElement;

    constructor(context: DrawCabinetInsideElement) {
        super();

        this.context = context;
    }

    public get minHeight(): number {
        return this.getMinLength(this.context.Height)?.millimeter || 0;
    }

    public get maxHeight(): number | null {
        return this.getMaxLength(this.context.Height)?.millimeter ?? null;
    }

    public get minWidth(): number {
        return this.getMinLength(this.context.Width)?.millimeter || 0;
    }

    public get maxWidth(): number | null {
        return this.getMaxLength(this.context.Width)?.millimeter ?? null;
    }

    protected getMinLength(length: Length): LengthValue {
        if (length instanceof RangeLength) {
            return length.start;
        } else if (length instanceof AutoLength || length instanceof StarLength || length == null) {
            return new LengthValueMillimeter(0);
        } else {
            return LengthMaths.getLengthValue(length);
        }
    }

    protected getMaxLength(length: Length): LengthValue | null {
        if (length instanceof RangeLength) {
            return length.stop;
        } else if (length instanceof AutoLength || length instanceof StarLength || length == null) {
            return null;
        } else {
            return LengthMaths.getLengthValue(length);
        }
    }
}